'use strict';

/**
 * Service: Order
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdJobService for ES6 usage
 *          5.3.0 #311 Add 'search_value'
 *          5.0.1 #286 Standardise Data Loading and Parsing Services
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2014-2020 Build Centrix
 */
var wdJobService = angular.module('wd.job',[])
    .factory(
    'wdJobService',
    [
        'wdOauth2HttpService', '$q', 'moment', 'wdApiResponseHandler', 'wdSharedFunctionsService',
        function (wdOauth2HttpService, $q, moment, wdApiResponseHandler, wdSharedFunctionsService)
        {
            // Initialize Service
            var service = {};

            //Clear Current Value
            service.jobs = [];
            service.jobCount = 0;

            // Variables
            var orderingApiUrl;

            /**
             * Count Orders
             *
             * @since 5.0.1
             * @returns {*}
             */
            service.getJobCount = function(parameters) {

                var deferred = $q.defer();

                //Clear Current Value
                service.jobCount = 0;

                // Ordering-api GET /orders
                var url = orderingApiUrl + 'jobs' + parameters;

                wdOauth2HttpService.get(url)
                    .then(
                    function (response) {

                        if (wdApiResponseHandler.isGoodResponseCode(response.status)) {

                            service.jobCount = response.data ? response.data : 0;
                            deferred.resolve(response);

                        } else {

                            deferred.reject(response);

                        }

                    }, function (response) {

                        deferred.reject(response);

                    }
                );

                return deferred.promise;

            };

            /**
             * Get Orders
             *
             * @since 5.0.1
             * @param {object} parameters
             * @returns {*}
             */
            service.getJobs = function (parameters) {

                var deferred = $q.defer();

                //Clear Current Values
                service.jobs = [];

                // Ordering-api GET /orders
                var url = orderingApiUrl + 'jobs' + parameters;

                wdOauth2HttpService.get(url)
                    .then(
                    function (response) {

                        if (wdApiResponseHandler.isGoodResponseCode(response.status)) {

                            service.jobs = response.data ? service.parseJobs(response.data) : [];
                            deferred.resolve(response);

                        } else {

                            deferred.reject(response);

                        }

                    }, function (response) {

                        deferred.reject(response);

                    }
                );

                return deferred.promise;
            };

            /**
             * Parse Jobs for Display
             *
             * @since 1.1.0
             * @param unparsedJobs
             * @returns {Array}
             */
            service.parseJobs =  function(unparsedJobs) {

                var results = [];

                for (var i = 0; i < unparsedJobs.length; i++) {

                    var currentJob = unparsedJobs[i];

                    /*jshint camelcase: false */
                    var id = parseInt(currentJob.index) ;
                    var jobName = wdSharedFunctionsService.convertStringToTitleCase(currentJob.name);
                    var jobNumber = currentJob.number;
                    var description = currentJob.description;
                    var created = currentJob.date_created ? currentJob.date_created : 'N/A';
                    var searchValue =  jobName + ' (' + jobNumber + ')';
                    var state = wdSharedFunctionsService.convertStringToTitleCase(currentJob.state);

                    results[i] = {
                        //Basic Details
                        id: id,
                        jobName: jobName,
                        name: jobName,
                        jobNumber: jobNumber,
                        number: jobNumber,
                        description: description,
                        dateCreated: created,
                        state: state,
                        search_value: searchValue,
                        selected: false,
                        rowClass: state==='Active' ? 'active-job-row' : 'archived-job-row'
                    };
                    /*jshint camelcase: true */

                }

                return results;

            };

            /**
             * Set Ordering Api Url
             *
             * @since 1.1.0
             *
             * @param {String} url
             * @returns {boolean}
             */
            service.setOrderingApiUrl = function (url) {

                orderingApiUrl = url;
                return true;

            };

            // Return Service
            return service;

        }
    ]
);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdJobService;
} 
// EOF
